export const messages = {
  en: {
    deleteStoreOrderUp: {
      title: 'Delete Store Order Up',
      confirm: 'Are you sure to delete this store order up?',
      deleteSuccess: 'Store order up deleted successfully',
      deleteFailed: 'Failed to delete store order up',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    deleteStoreOrderUp: {
      title: '删除店铺订单上架',
      confirm: '确定要删除这个店铺订单上架吗？',
      deleteSuccess: '店铺订单上架删除成功',
      deleteFailed: '店铺订单上架删除失败',
      cancel: '取消',
      confirmDelete: '确认删除'
    }
  }
}